
import { AmmunitionStockEventEntityDecorator } from './ammunition-stock-event.decorator';
import { AmmunitionStockEvent } from './ammunition-stock-event.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class AmmunitionStockEventTypeInfoBase implements CrudTypeInfo<AmmunitionStockEvent, number> {
  name = 'Ammunition Stock Event';
  entityDecorator = new AmmunitionStockEventEntityDecorator();
  
  createAuthorities = ['WRITE_AMMUNITION_STOCK_EVENT'];
  editAuthorities = ['WRITE_AMMUNITION_STOCK_EVENT'];
  deleteAuthorities = ['WRITE_AMMUNITION_STOCK_EVENT'];
  viewAuthorities = ['READ_AMMUNITION_STOCK_EVENT'];
  
  searchRouteBase = ['/ammunitionstockevent/search'];
  createRouteBase = ['/ammunitionstockevent/create'];
  editRouteBase = ['/ammunitionstockevent/edit'];
  viewRouteBase = ['/ammunitionstockevent/view'];
  
  description(item: AmmunitionStockEvent): string {
    return '' +  item.ammunitionStockEventId;
  }
}



